import React, { use } from 'react';

export type OperationsViewInfo = {
  sitesCount: number;
  binsCount: number;
  fansCount: number;
  allSitesGrainLevelCount: number;
};

type TContext = OperationsViewInfo | undefined;

type OperationsViewInfoContextValue = {
  info: TContext;
  setInfo: (value: TContext) => void;
};

export const OperationsViewInfoContext = React.createContext<OperationsViewInfoContextValue>({
  info: undefined,
  setInfo: () => {},
});

export const OperationsViewInfoProvider = ({
  allSiteInfo,
  children,
}: React.PropsWithChildren<{ allSiteInfo?: OperationsViewInfo }>) => {
  const [context, setContext] = React.useState<TContext>(allSiteInfo || undefined);
  const value = React.useMemo(
    () => ({
      info: context,
      setInfo: setContext,
    }),
    [context]
  );

  return <OperationsViewInfoContext value={value}>{children}</OperationsViewInfoContext>;
};

export function useOperationsViewInfo() {
  return use(OperationsViewInfoContext);
}
